"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * ComboBox
 * @param {*} props
 * https://react-select.com/home
 * https://www.npmjs.com/package/react-multi-select-component
 * https://github.com/Khan/react-multi-select/
 * https://material-ui.com/pt/components/selects/
 */
var Combobox = function Combobox(props) {
  return /*#__PURE__*/_react["default"].createElement("select", props, /*#__PURE__*/_react["default"].createElement("option", null, "Op\xE7\xE3o"));
};

var _default = Combobox;
exports["default"] = _default;